import { render, staticRenderFns } from "./DecisionAid.vue?vue&type=template&id=d8c68af2&"
import script from "./DecisionAid.vue?vue&type=script&lang=js&"
export * from "./DecisionAid.vue?vue&type=script&lang=js&"
import style0 from "./DecisionAid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports